export const WEBENGAGE_EVENTS = {
    Auth: {
        OTP_REQUESTED: "auth.otp_requested",
        OTP_VERIFIED: "auth.otp_verified",
        SIGNUP_SUCCESS: "auth.signup_success",
        LOGIN_SUCCESS: "auth.login_success",
        AUTH_SUCCESS: "auth.auth_success",
    },
    Test: {
        ATTEMPTED: "test.test_attempted",
        CREATED: "test.test_created",
        BEGIN: "test.test_began",
        FINISH: "test.test_finish",
        REPORT_VIEWED: "test.report_viewed",
        SOLUTION_VIEWED: "test.solutions_viewed",
    },
};
